import { preventStopPropagation } from "@/utils/domUtils";
import Dialog from "@mui/material/Dialog";
import React, { useState } from "react";

const ZoomableImage = ({
    isOpen,
    onClose,
    img,
    alt,
}: {
    isOpen: boolean;
    onClose: () => void;
    img: string;
    alt: string;
}) => {
    const [isZoomed, setIsZoomed] = useState(false);
    const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

    const handleClose = () => {
        setIsZoomed(false);
        onClose();
    };

    const handleImageClick = (e: React.MouseEvent<HTMLImageElement>) => {
        const container = e.currentTarget.getBoundingClientRect();
        const x = (e.nativeEvent.clientX - container.left) / container.width;
        const y = (e.nativeEvent.clientY - container.top) / container.height;

        setCursorPosition({ x, y });
        setIsZoomed(!isZoomed);
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        const container = e.currentTarget.getBoundingClientRect();
        const x = (e.nativeEvent.clientX - container.left) / container.width;
        const y = (e.nativeEvent.clientY - container.top) / container.height;

        setCursorPosition({ x, y });
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(e, reason) => {
                if (reason === "backdropClick") {
                    preventStopPropagation(e);
                }
                handleClose();
            }}
            disableScrollLock
            PaperProps={{
                style: {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    overflow: "visible",
                },
            }}
            TransitionProps={{ unmountOnExit: true, mountOnEnter: true }}>
            <div
                className="scrollbar"
                onClick={preventStopPropagation}
                style={{ overflow: "auto", position: "relative", width: "100%", height: "100%" }}
                onMouseMove={isZoomed ? handleMouseMove : undefined}
                data-testid="auto-id-70d9d3f9-db94-413b-98c3-c66a1864a264">
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        transformOrigin: `${cursorPosition.x * 100}% ${cursorPosition.y * 100}%`,
                        transition: "transform 0.2s",
                        transform: isZoomed ? "scale(2.3)" : "none",
                    }}
                    data-testid="auto-id-fe4a35f4-81f6-4066-8d70-455d754d8822">
                    {/* biome-ignore lint: noInvalidUseBeforeDeclaration */}
                    <img
                        alt={alt}
                        src={img}
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "transparent",
                            cursor: isZoomed ? "zoom-out" : "zoom-in",
                            objectPosition: "center center",
                        }}
                        onClick={handleImageClick}
                        rel="nofollow"
                        data-testid="auto-id-7c769283-9811-43b8-bf24-bab3249f1467" />
                </div>
            </div>
        </Dialog>
    );
};

export default ZoomableImage;
